import TemplateView from "../../../../TemplateView"
import messageResource from "../../../../messageResource"
import CounterWithProgressBar from "../../../../components/counterCPT/CounterWithProgressBar"
import {HierarchyLevels} from "constants"
import {customerNameLower, projectNameLower, taskNameLower} from '../../../../util/pluralizeUtils'

export default class TabContainer extends TemplateView {
    constructor({
        onTabChanged = (tab) => {}
    }) {
        super();

        this.params = {
            onTabChanged,
        }

        this.state = {
            customers: {
                curValue: 0,
                maxValue: 0,
            },
            projects: {
                curValue: 0,
                maxValue: 0,
            },
            tasks: {
                curValue: 0,
                maxValue: 0,
            },
            selectedTab: "",
        }

        this.onStatePropertyChanged(
            'customers',
            (values) =>
                this._updateTab({
                    tab: this.customerTab,
                    values: values,
                    title: messageResource.getMessage('userlist.work_assignments.active') + " " + customerNameLower(values.curValue),
                })
        )

        this.onStatePropertyChanged(
            'projects',
            (values) =>
                this._updateTab({
                    tab: this.projectTab,
                    values: values,
                    title: messageResource.getMessage('userlist.work_assignments.active') + " " + projectNameLower(values.curValue),
                })
        )

        this.onStatePropertyChanged(
            'tasks',
            (values) =>
                this._updateTab({
                    tab: this.taskTab,
                    values: values,
                    title: messageResource.getMessage('userlist.work_assignments.open') + " " + taskNameLower(values.curValue),
                })
        )

        this.onStatePropertyChanged('selectedTab', (hierarchyLevel) => {
            for (const level of Object.values(HierarchyLevels)) {
                this.$tabs[level].toggleClass("selected", hierarchyLevel === level)
            }

            this.$arrow.toggleClass('taskArrow', hierarchyLevel === HierarchyLevels.TASK)
            this.$arrow.toggleClass('projectArrow', hierarchyLevel === HierarchyLevels.PROJECT)
            this.$arrow.toggleClass('customerArrow', hierarchyLevel === HierarchyLevels.CUSTOMER)
        })
    }

    templateHtml() {
        return "<div class='tabsContainer'>" +
               "    <div class='arrow'/>" +
               "    <div class='customerTabHeader tabHeader'></div>" +
               "    <div class='projectTabHeader tabHeader'></div>" +
               "    <div class='taskTabHeader tabHeader'></div>" +
               "</div>"
    }

    afterRender() {
        this.$arrow = this.find('.arrow')
        this.$tabs = {};
        this.$tabs[HierarchyLevels.CUSTOMER] = this.find(".customerTabHeader");
        this.$tabs[HierarchyLevels.PROJECT] = this.find(".projectTabHeader");
        this.$tabs[HierarchyLevels.TASK] = this.find(".taskTabHeader");

        this.customerTab = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
            hasProgressBar: true,
        }).init(this.$tabs[HierarchyLevels.CUSTOMER]);
        this.$tabs[HierarchyLevels.CUSTOMER].click(() => {
            if (this.state.customers.maxValue > 0 && !this._areAllTabsEmpty())
                this.params.onTabChanged(HierarchyLevels.CUSTOMER)
        })

        this.projectTab = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.PROJECT,
            hasProgressBar: true,
        }).init(this.$tabs[HierarchyLevels.PROJECT])
        this.$tabs[HierarchyLevels.PROJECT].click(() => {
            if (this.state.projects.maxValue > 0 && !this._areAllTabsEmpty())
                this.params.onTabChanged(HierarchyLevels.PROJECT)
        })

        this.taskTab = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.TASK,
            hasProgressBar: true,
        }).init(this.$tabs[HierarchyLevels.TASK])
        this.$tabs[HierarchyLevels.TASK].click(() => {
            if (this.state.tasks.maxValue > 0 && !this._areAllTabsEmpty())
                this.params.onTabChanged(HierarchyLevels.TASK)
        })
    }

    _areAllTabsEmpty() {
        return this.state.tasks.curValue === 0 && this.state.projects.curValue === 0 && this.state.customers.curValue === 0
    }

    _updateTab({tab, values, title}) {
        const allTabsEmpty = this._areAllTabsEmpty()
        this.$arrow.toggle(!allTabsEmpty)
        const active = values.maxValue > 0 && !allTabsEmpty
        tab.setState({
            ...values,
            active: active,
            pale: true,
            title: title,
        });

        this.$tabs[tab.props.hierarchyLevel].toggleClass('inactive', !active)
        this.$tabs[tab.props.hierarchyLevel].toggleClass('active', active)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/TabContainer.js